import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAudioTechnicaComponent } from './simple-icons-audio-technica.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAudioTechnicaComponent ],
    exports:      [ SimpleIconsAudioTechnicaComponent ],
    bootstrap:    []
})
export class SimpleIconsAudioTechnicaModule {}
